import * as z from 'zod';

export const splunkPartition = z.object({
  web_ui: z.string().max(100).optional(),
  web_port: z.coerce.number().max(65535).optional(),
  address: z.string().max(100).nonempty('This field is required'),
  admin_port: z.coerce.number().min(1).max(65535).default(8086).optional(),
  scheme: z.enum(['http', 'https']).default('https'),
  verify_ssl: z.boolean().default(false),
  use_token_auth: z.boolean().default(false),
  token: z.string().max(2000).optional(),
  index: z.string().max(100).optional(),
  username: z.string().max(100).optional(),
  password: z.string().max(100).optional(),
  use_basic_auth: z.boolean().default(true),
  timestamp_offset: z.coerce.number().min(0).max(60).default(1),
  use_job_export: z.boolean().default(true),
  job_timeout: z.coerce.number().min(1).max(3600).default(60),
  source_type_time_range: z.coerce.number().min(1).max(24).default(24),
  source_type_field_time_range: z.coerce.number().min(1).max(24).default(24),
  earliest_lookback: z.coerce.number().min(1).max(24).default(8),
  mapping_type: z.enum(['metadata', 'tstats']).default('metadata'),
  enable_source_type_alt: z.boolean().default(false),
  source_type_alt: z.enum(['sourcetype', 'source']),
  use_asset_filtering: z.boolean().default(false).optional(),
  store_event_raw: z.boolean().default(false),
  notable_events_macro: z.string().max(50).default('notable'),
  notable_events_indexes: z.string().max(100).optional(),
  use_search_id_for_contributing_events_query: z.boolean().default(false),
  generate_alert_as_events: z.boolean().default(false)
});

export const splunkAttackIqPartition = z.object({
  enrich_alerts: z.boolean().default(true),
  disposition: z.coerce.number().min(0).max(99999).default(2),
  use_security_events: z.enum(['custom_rules', 'all', 'security_events'])
});

const mode = z.enum(['Automatic', 'Ad Hoc']);

export type SplunkMode = z.infer<typeof mode>;

export const splunkGeneralPartition = z.object({
  display_name: z.string().max(50).nonempty('This field is required'),
  description: z.string().max(200).optional(),

  mode
});

export const splunkConfigFormSchema = z
  .object({
    general: splunkGeneralPartition.required(),
    splunk_es_stream: splunkPartition,
    attack_iq: splunkAttackIqPartition.required()
  })
  .superRefine((data, ctx) => {
    if (data.splunk_es_stream.use_basic_auth && (!data.splunk_es_stream.username || !data.splunk_es_stream.password)) {
      ctx.issues.push({
        path: ['splunk_es_stream.username'],
        code: 'custom',
        message: 'Username is required',
        input: ''
      });

      ctx.issues.push({
        path: ['splunk_es_stream.password'],
        code: 'custom',
        message: 'Password is required',
        input: ''
      });
    }
    if (data.splunk_es_stream.use_token_auth && !data.splunk_es_stream.token) {
      ctx.issues.push({
        path: ['splunk_es_stream.token'],
        code: 'custom',
        message: 'Token is required',
        input: ''
      });
    }
  });

export type SplunkConfig = z.infer<typeof splunkConfigFormSchema>;
